import { buildLogoOriginPreconnectLink, buildLogoPreloadLink } from './lcpResourceHints';
/** Script-Tag-ID für eingebettete Site-Config (liegt bewusst außerhalb #app). */
export const PRERENDER_SITE_CONFIG_SCRIPT_ID = 'tastio-prerender-site-config';
const escapeJsonForHtml = (value) => JSON.stringify(value).replace(/</g, '\\u003c');
export const readPrerenderSiteConfigFromDocument = () => {
    if (typeof document === 'undefined')
        return null;
    const node = document.getElementById(PRERENDER_SITE_CONFIG_SCRIPT_ID);
    if (!node?.textContent?.trim())
        return null;
    try {
        const parsed = JSON.parse(node.textContent);
        if (!parsed?.project?.name)
            return null;
        return parsed;
    }
    catch {
        return null;
    }
};
export const buildPrerenderSiteConfigScript = (config) => {
    const json = escapeJsonForHtml(config);
    return `<script type="application/json" id="${PRERENDER_SITE_CONFIG_SCRIPT_ID}">${json}</script>`;
};
export const injectPrerenderSiteConfigIntoHtml = (html, config) => {
    if (!config?.project?.name)
        return html;
    let result = html;
    const script = buildPrerenderSiteConfigScript(config);
    if (result.includes('</body>')) {
        result = result.replace('</body>', `${script}</body>`);
    }
    else {
        result = `${result}${script}`;
    }
    const logoUrl = config.branding?.logoUrl?.trim();
    if (logoUrl && result.includes('</head>')) {
        const hints = [
            buildLogoOriginPreconnectLink(logoUrl),
            buildLogoPreloadLink(logoUrl)
        ].filter(Boolean).join('\n');
        result = result.replace('</head>', `${hints}</head>`);
    }
    return result;
};
